var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"models"}},[_c('h1',[_vm._v("Choisir un model")]),_c('p',[_vm._v("blabla")]),_c('div',{staticClass:"models-list"},_vm._l((_vm.models),function(model){return _c('model',{key:model.id,attrs:{"model":model}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }